
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST } from '../../../_getjson';
import isArrayInArray2D from '../../../CustomFunction/Arraymanage/isArrayInArray2D'
import Grid from '@mui/material/Grid';

import CustomBackdrop from '../../../Components/CustomBackdrop/Barckdrop';

import { Box, Button, ButtonGroup } from '@mui/material';
export default function Csprepayment(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);
    const [Isload, setIsload] = useState(false)
    var rowStrAll = []
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        // console.log(parm);
        // console.log(props);
        // var url = "CSAPDEPOSIT/GET?APCODE=" + parm.APCode + "&DOCNO=" + (parm.docno ? parm.docno : "")
        // console.log(genURL(url));
        // axios.get(genURL(url), { timeout: 3600 }).then((res) => {
        //     if (res.data.length < 0) {
        //         setListitem(res.data)
        //     }
        // })
        loadeData()
    }

    const loadeData = () => {
        setIsload(true)
        let items = []
        let url = `/csapdeposit/Popupdata?APCode=${parm.APCode}`
        axios.get(genURL(url)).then(res => {
            setListitem(res.data)
            // for (let i = 0; i < res.data.length; i++) {
            //     items[i] = {
            //         ALLOCATECODE: res.data[i].ALLOCATECODE,
            //         DEBTAMOUNT: res.data[i].DEBTAMOUNT,
            //         DEBTBALANCE: res.data[i].DEBTBALANCE,
            //         DEPARTMENT: res.data[i].DEPARTMENT,
            //         DEPOSITNO: res.data[i].DEPOSITNO,
            //         DOCDATE: res.data[i].DOCDATE,
            //         EXCHANGERATE: res.data[i].EXCHANGERATE,
            //         ISTAX: res.data[i].ISTAX,
            //         PROJECT: res.data[i].PROJECT,
            //         REMARK: res.data[i].REMARK,
            //         SELFLAG: res.data[i].SELFLAG,
            //         SITECODE: res.data[i].SITECODE,
            //         TAXRATE: res.data[i].TAXRATE,
            //         TAXTYPE: res.data[i].TAXTYPE,
            //         USERCODE: res.data[i].USERCODE
            //     }
            // }
        }
        ).finally(_ => {
            //  setListitem(items)
            setIsload(false)
        })
    }
    const selectRowProp = {
        mode: 'checkbox',
        onSelect: onRowSelect,
        onSelectAll: onSelectAll
    };
    async function onRowSelect(row, isSelected, e) {
        if (isSelected) {
            await rowStrAll.push(row)
        } else if (!isSelected) {
            let rowStrremove = [];
            rowStrremove.push(row);
            rowStrAll = await isArrayInArray2D(rowStrAll, rowStrremove, "REFDOCNO")
        }
    }
    async function onSelectAll(isSelected, rows) {
        if (isSelected) {
            for (let index = 0; index < rows.length; index++) {
                rowStrAll.push(rows[index])
            }
            console.log("rowStradd", rowStrAll);
        } else {
            rowStrAll = []
        }
    }

    const sendData = (row) => {
        //เช็ค push ซ้ำ 222
        if (row) {
            for (let index = 0; index <= rowStrAll.length; index++) {
                if (rowStrAll.length === 0) {
                    rowStrAll.push(row)
                } else if (rowStrAll.length < 0) {
                    if (row.DEPOSITNO !== rowStrAll[index].DEPOSITNO) {
                        rowStrAll.push(row)
                    }
                }
            }
        }
        let resdatas = []
        resdatas.push(false)
        resdatas.push("SelAPDepositUse") //ส่งกลับเพื่อเป็นเงือนไขที่มา
        resdatas.push(rowStrAll)
        props.resdata(resdatas)
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    return (
        <>
            {/* <button onClick={() => sendData("")}>ตกลง</button> */}
            <Box display="flex" justifyContent="flex-start" m={1} pb={1} >
                <ButtonGroup aria-label="outlined inherit button group"  >
                    <Button size='small' onClick={() => sendData("")} color="inherit" variant="contained"> ตกลง </Button>
                    {/* <Button size='small' disabled={deleteEnable} onClick={_ => deleteRowsClick()} color="inherit" variant="contained">ลบ</Button> */}
                </ButtonGroup>
            </Box>

            <BootstrapTable
                data={listitem}
                options={{
                    onRowDoubleClick: sendData,
                    noDataText: "ไม่พบข้อมูล"
                }}
                selectRow={selectRowProp}
                height='500'
            >
                {/* <TableHeaderColumn dataAlign="center" width="30" dataField="id" isKey></TableHeaderColumn> */}
                <TableHeaderColumn dataAlign="center" width="30" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='DEPOSITNO' dataAlign="center" editable={false} isKey> เลขที่ใบรับ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="90" dataField='DOCDATE' editable={false}> วันที่รับ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='REMARK' dataAlign="left" editable={false}> หมายเหตุ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="90" dataField='DEBTAMOUNT' dataAlign="left" editable={false}> จำนวนเงินทั้งสิ้น </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="90" dataField='DEBTBALANCE' dataAlign="left" editable={false}> ยอดเงินคงเหลือ </TableHeaderColumn>
            </BootstrapTable>
            <Box display="flex" justifyContent="flex-start" m={1} pb={1} >
                <ButtonGroup aria-label="outlined inherit button group"  >
                    <Button onClick={() => sendData("")} variant="contained" size='small'>ตกลง</Button>
                </ButtonGroup>
            </Box>

            <CustomBackdrop open={Isload} />
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />
        </>)
}
Csprepayment.prototype = {
    parm: PropTypes.array,
}
